import { render, staticRenderFns } from "./AsideNavigationMenuWithCollapse.vue?vue&type=template&id=6168ea23&scoped=true&"
import script from "./AsideNavigationMenuWithCollapse.vue?vue&type=script&lang=js&"
export * from "./AsideNavigationMenuWithCollapse.vue?vue&type=script&lang=js&"
import style0 from "./AsideNavigationMenuWithCollapse.vue?vue&type=style&index=0&id=6168ea23&scoped=true&lang=css&"
import style1 from "./AsideNavigationMenuWithCollapse.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6168ea23",
  null
  
)

export default component.exports